
// import React from "react";
// import DynamicSitemap from "react-dynamic-sitemap";
// import parse from 'html-react-parser';

import Routes from './SiteMap/TheRouts';
import { useEffect } from "react";
import { useState } from "react";
import { CompressOutlined } from "@mui/icons-material";
import parse from 'html-react-parser';
import ConnUrls from '../Connections/ConnectURL';
import { Helmet } from 'react-helmet';

// var fs = require('fs');
// var builder = require("xmlbuilder");

// const router = require('../web_pages/Routes');



const Page_404 = (props) => {

   


    const [stMapBack, setStMapBack] = useState();

    useEffect(() => {
        // props.shoTopStrp(false)
        // props.showfotter(false)
        // props.setYesStrip(false)

    }, [])

    useEffect(async () => {

        // console.log(stmap)


    }, []);




    return (
        <>
            <div className={"page_404"}>
                <h1 class={"big"}>אופססס!</h1>
                <p class={"small"}>דף זה לא נמצא</p>
                <br />
                <a href='/'>המשך</a>
                <div className={"imgOn404"} style={{ backgroundImage: `url(${ConnUrls.servMediasUrl}Uploads/MASTER/ops.jpg)` }}></div>
            </div>

            <Helmet
                meta={[
                    {
                        property: "og:url", content: `${ConnUrls.siteDomainNam}/err404`
                    }
                ]}>
                <link rel="canonical" href={`${ConnUrls.siteDomainNam}/err404`} />
            </Helmet>
        </>
    )


}

export default Page_404;